var parse=require('../parse/index.js');/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */function getDate(dirtyDate){var date=parse(dirtyDate);var dayOfMonth=date.getDate();return dayOfMonth;}module.exports=getDate;